import {
  AnyAction,
  applyMiddleware,
  compose,
  createStore,
  Middleware,
  Store,
} from "redux";
import { extractUriRoute, getLocationOrigin } from "./utils";
import { pushRoute } from "./redux/modules/route/actions";
import { log } from "./redux/modules/logger/actions";
import { EVENT_APP_STARTED } from "./redux/modules/logger/constants";

import thunk, { ThunkDispatch } from "redux-thunk";
import {
  crashReporterMiddleware,
  logInfoMiddleware,
} from "./redux/modules/logger/middleware";
import { ROUTE_PUSHED } from "./redux/modules/route/reducer";
import { AUTH_STATUS } from "./redux/modules/user/reducer";

import * as L from "leaflet";
import rootReducer, { GlobalState } from "./redux/modules/rootReducer";
import { IBwaIoGateway } from "./io/ioGateway";
import config from "./config";
import createRuntimeIoGateway from "./io/runtimeIoGateway";

export type AppStore = Store<GlobalState> & {
  dispatch: ThunkDispatch<GlobalState, IBwaIoGateway, AnyAction>;
};
export type AppDispatch = ThunkDispatch<GlobalState, IBwaIoGateway, AnyAction>;
export type AppGetState = () => GlobalState;

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const createIsolatedStore = (io: IBwaIoGateway): AppStore =>
  createStore(
    rootReducer,
    {},
    composeEnhancers(applyMiddleware(thunk.withExtraArgument(io))),
  );

/**
 * @deprecated
 * Use createIsolatedStore when all middlewares will be replaced with thunk actions
 * and all IO will be passed through thunk extra argument
 */
export function configureStore(initialState = {}): AppStore {
  const store: AppStore = createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(
        crashReporterMiddleware,
        logInfoMiddleware,
        thunk.withExtraArgument(createRuntimeIoGateway()), // allow to dispatch a function
        updateLocation, // update page location on route change
      ),
    ),
  );

  window.addEventListener("hashchange", () => {
    const newURL = window.location.href; // IE10 does'nt support `newUrl` event argument
    const newPath = newURL.split("#")[1];
    const currentRoute = store.getState().route;
    if (currentRoute === newPath) {
      return;
    }
    store.dispatch(pushRoute(extractUriRoute(newURL)));
  });

  const humanReadableBrowserProperties = Object.keys(L.Browser)
    .filter((k: keyof typeof L.Browser) => L.Browser[k])
    .join(",");
  const { userAgent } = navigator;

  store.dispatch(
    log(
      EVENT_APP_STARTED,
      "1",
      JSON.stringify({ humanReadableBrowserProperties, userAgent }),
      true,
    ),
  );

  return store;
}

// MIDDLEWARES
// TODO: get rid of middlewares (#366)

// modifies hash history when route is changed
const updateLocation: Middleware = () => next => action => {
  if (action && action.type === ROUTE_PUSHED) {
    window.location.href = getLocationOrigin() + "/#" + action.payload;
  }

  return next(action);
};
